/**
 * Project photos in `public/gallery/` — single source for Home hero, About, Gallery.
 * Paths are URL-encoded for filenames with spaces and parentheses.
 */

export const GALLERY_IMAGE_FILES = [
  'WhatsApp Image 2026-04-19 at 12.11.06 AM.jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.07 AM (1).jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.07 AM.jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.08 AM (1).jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.08 AM (2).jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.08 AM.jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.09 AM (1).jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.09 AM (2).jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.09 AM.jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.10 AM (1).jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.10 AM.jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.11 AM (1).jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.11 AM (2).jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.11 AM.jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.12 AM (1).jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.12 AM.jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.13 AM (1).jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.13 AM (2).jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.13 AM.jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.14 AM (1).jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.14 AM.jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.15 AM (1).jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.15 AM.jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.16 AM (1).jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.16 AM (2).jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.16 AM.jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.17 AM (1).jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.17 AM (2).jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.17 AM.jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.18 AM.jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.19 AM (1).jpeg',
  'WhatsApp Image 2026-04-19 at 12.11.19 AM.jpeg',
];

const CATEGORIES = ['Pharmaceutical', 'Food & beverage', 'Warehouse', 'Manufacturing', 'Industrial'];

export function galleryUrl(filename) {
  return `/gallery/${encodeURIComponent(filename)}`;
}

/** Safe index into the project photo set (wraps if needed). */
export function galleryImageAt(index) {
  if (!GALLERY_IMAGE_FILES.length) return '';
  return galleryUrl(GALLERY_IMAGE_FILES[index % GALLERY_IMAGE_FILES.length]);
}

/** Full grid: every image with labels for the Gallery page */
export const GALLERY_GRID_ITEMS = GALLERY_IMAGE_FILES.map((file, index) => ({
  url: galleryUrl(file),
  title: `Project installation ${index + 1}`,
  category: CATEGORIES[index % CATEGORIES.length],
}));

/** Home hero carousel — first five images; caption shows under the framed photo */
export const HOME_HERO_SLIDES = GALLERY_IMAGE_FILES.slice(0, 5).map((file, index) => ({
  url: galleryUrl(file),
  alt: `Sai Vikas industrial flooring — project ${index + 1}`,
  caption: ['Industrial & warehouse flooring', 'Epoxy plant installation', 'Clean process areas', 'Food & pharma facilities', 'Pan-India project execution'][index] || `Project ${index + 1}`,
}));

/** About page: hero background + split section image */
export const ABOUT_HERO_IMAGE = galleryUrl(GALLERY_IMAGE_FILES[0]);
export const ABOUT_SIDE_IMAGE = galleryUrl(GALLERY_IMAGE_FILES[1] || GALLERY_IMAGE_FILES[0]);
